@let hasPermissionForWorkflow = hasPermissionForWorkflow$ | async;

@if (schedules.length > 0) {
  <div class="grid mb-2">
    <div class="col-3 text-lg font-bold">{{ 'msg.workspace.settings.schedules.column.name' | translate }}</div>
    <div class="col-2 text-lg font-bold">{{ 'msg.workspace.settings.schedules.column.timezone' | translate }}</div>
    <div class="col-2 text-lg font-bold">{{ 'msg.workspace.settings.schedules.column.cron' | translate }}</div>
    <div class="col-3 text-lg font-bold">{{ 'msg.workspace.settings.schedules.column.options' | translate }}</div>
    <div class="col-2 text-lg font-bold"></div>
  </div>
}
<div class="scheduleList">
  <ng-container *ngFor="let schedule of schedules">
    <div class="grid" *ngIf="!showEditForms[schedule.id]">
      <div class="col-3">{{ getPresetName(schedule.executionInfo.presetId) }}</div>
      <div class="col-2">{{ schedule.schedule.timezone }}</div>
      <div class="col-2">{{ schedule.schedule.cron }}</div>
      <div class="col-3">
        <i
          *ngIf="schedule.runClone"
          class="pi pi-copy text-primary mr-2"
          pTooltip="{{ 'schedules.form.tooltip.runClone' | translate }}"
          tooltipPosition="top"
        ></i>
        <i
          *ngIf="schedule.stopSessionBeforeRun"
          class="pi pi-refresh text-primary"
          pTooltip="{{ 'schedules.form.tooltip.stopSessionBeforeRun' | translate }}"
          tooltipPosition="top"
        ></i>
      </div>
      <div class="col-2 flex justify-content-end actions">
        <button
          *ngIf="(permissions$ | async)['canEdit'] && hasPermissionForWorkflow"
          pButton
          type="button"
          class="p-button-text p-button-link"
          appearance="icon"
          icon="pi pi-pen-to-square"
          pTooltip="{{ 'msg.workspace.settings.schedules.button.edit' | translate }}"
          tooltipPosition="top"
          (click)="editScheduleChange(schedule.id)"
        ></button>
        <button
          *ngIf="(permissions$ | async)['canDelete'] && hasPermissionForWorkflow"
          pButton
          class="p-button-text p-button-link"
          icon="pi pi-trash"
          appearance="icon"
          severity="danger"
          pTooltip="{{ 'msg.workspace.settings.schedules.button.delete' | translate }}"
          tooltipPosition="top"
          (click)="onDeleteSchedule(schedule.id)"
        ></button>
      </div>
    </div>
    <selfai-platform-workflow-settings-schedules-form
      *ngIf="showEditForms[schedule.id]"
      [presets]="presets"
      [schedule]="schedule"
      [workflowId]="workflowId"
      (cancelEvent)="editScheduleChange(schedule.id)"
      (submitEvent)="onEditSchedule($event)"
    ></selfai-platform-workflow-settings-schedules-form>
  </ng-container>
  <selfai-platform-workflow-settings-schedules-form
    *ngIf="showCreateForm"
    [presets]="presets"
    [workflowId]="workflowId"
    (cancelEvent)="addScheduleChange()"
    (submitEvent)="onAddSchedule($event)"
  ></selfai-platform-workflow-settings-schedules-form>
</div>

<div class="flex between">
  <p-button
    *ngIf="(permissions$ | async)['canCreate'] && hasPermissionForWorkflow && !showCreateForm"
    class="overlay"
    icon="pi pi-plus-circle"
    [rounded]="false"
    severity="success"
    [label]="'msg.workspace.settings.schedules.tooltip.add-schedule' | translate"
    (click)="addScheduleChange()"
  ></p-button>
</div>
